import { createAction } from '@reduxjs/toolkit';
import { responseFailed, accountServiceFailed } from './error';
import { getValidCurrentAccounts } from 'utils/accountUtil';
import { LOAN_TYPE, PRE_ASSESSED_JOURNEY } from 'constants/general';
import { navigateToScreen } from './navigation';
import { INELIGIBILTY_SCREEN } from 'constants/paths';
import { showHideLoader } from './loader';

const getAccountList = createAction('account/getAccountList', function prepare(showLoader = false) {
  return {
    payload: {
      endPoint: `banks/:bankId/accounts/default`,
      method: 'get',
      isPaasApi: true,
      addHeader: true,
      success: accountListSuccess,
      successParam: {
        showLoader
      },
      failure: accountServiceFailed,
      failedParam: {
        showLoader
      },
      version: '1.2.0'
    }
  };
});

const accountListSuccess = (response, param) => (dispatch, getState) => {
  if (response) {
    const accounts = getValidCurrentAccounts(response.accounts);
    dispatch(accountListSuccessResponse(response.accounts));
    const {
      config: { journey }
    } = getState();

    if (accounts.length === 0 && journey === PRE_ASSESSED_JOURNEY) {
      dispatch(navigateToScreen(INELIGIBILTY_SCREEN));
    } else if (accounts.length === 1) {
      dispatch(setDrawDownAccount(accounts[0].id));
      dispatch(setRepaymentAccount(accounts[0].id));
      dispatch(setMainBankAccount(accounts[0].id));
    }

    const loanAccounts = response.accounts.filter(
      (account) =>
        account.type === LOAN_TYPE && account.balances && account.balances[0].amount.value
    );
    if (loanAccounts.length > 0) {
      dispatch(setAccountCount(loanAccounts.length));
      loanAccounts.forEach((account) => dispatch(accountDetailsById(account.id)));
    } else {
      dispatch(showHideLoader(param.showLoader));
    }
  } else dispatch(responseFailed(response));
};

const accountListSuccessResponse = createAction(
  'account/accountListSuccessResponse',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

const accountDetailsById = createAction('account/accountDetailsById', function prepare(accountId) {
  return {
    payload: {
      endPoint: `banks/:bankId/accounts/default/${accountId}`,
      method: 'get',
      isPaasApi: true,
      addHeader: true,
      success: accountDetailsByIdSuccess,
      failure: responseFailed,
      version: '1.2.0'
    }
  };
});

const accountDetailsByIdSuccess = createAction(
  'account/accountDetailsByIdSuccess',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

const setAccountCount = createAction('account/setAccountCount', function prepare(count) {
  return {
    payload: count
  };
});

const setDrawDownAccount = createAction('account/setDrawDownAccount', function prepare(accountId) {
  return {
    payload: accountId
  };
});

const setRepaymentAccount = createAction(
  'account/setRepaymentAccount',
  function prepare(accountId) {
    return {
      payload: accountId
    };
  }
);

const setMainBankAccount = createAction('account/setMainBankAccount', function prepare(accountId) {
  return {
    payload: accountId
  };
});

export {
  getAccountList,
  accountListSuccessResponse,
  setDrawDownAccount,
  setRepaymentAccount,
  setMainBankAccount,
  setAccountCount,
  accountDetailsByIdSuccess,
  accountListSuccess
};
